// Libs
import React, { Component } from 'react'
import { Row, Col } from '../../components/Elemental'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { reset, change, arrayPush } from 'redux-form'
import _ from 'lodash'

// CSS
import './styles.scss'

// Components/Containers
import Breadcrumb from '../../components/Breadcrumb'
import Button from '../../components/Button'
import Pagination from '../../components/Pagination'
import LoadingBox from '../../components/LoadingBox'
import NotFoundBox from '../../components/NotFoundBox'
import MyCasesPageCard from './components/MyCasesPageCard'
import MyCasesPageFilter from './components/MyCasesPageFilter'

// Actions
import { changeFilterVisible, changeFilterClassifiers, fetchSpCases, fetchFilters, fetchFiltersClassifiers, fetchFiltersArchiveReasons } from './actions'

// Imgs
import notFoundImg from '../../assets/not-found.svg'

import withParams from '../../hoc/WithParams'

class MyCasesPage extends Component {
  UNSAFE_componentWillMount() {
    const { filter: defaultFilter, user, total, offset, perPage, fetchClassifiers, fetchSpCases, fetchFilters, fetchFiltersClassifiers, fetchFiltersArchiveReasons, reset, change } = this.props
    const action = offset === 0 ? 'first' : null
    const { search } = this.props.location
    let filter = defaultFilter ? defaultFilter : {}

    if (search) {
      let filters = search.substr(1).split('&')

      reset('filter')

      filters.map(item => {
        const splittedItem = item.split('=')
        const key = splittedItem[0]
        let values = splittedItem[1].split(';')

        if (key.indexOf('archiving') != -1 || key.indexOf('entries') != -1) {
          values = values[0]
        }

        if (key.indexOf('classifiers') != -1) {
          values = values.map(value => {
            if (value === 'None') {
              return value
            }

            return Number(value)
          });
        }

        filter = { ...filter, values: { ...filter.values, [key]: values } }

        change('filter', key, values)
      })
    }

    fetchFilters(user.id)
    fetchFiltersClassifiers()
    fetchFiltersArchiveReasons()
    fetchSpCases(user.id, 'first', total, offset, perPage, filter)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { user, total, offset, perPage, filter, spCases, notifications, onboarding, changeFilterClassifiers, fetchSpCases, fetchFiltersClassifiers } = this.props
    const nextSpCases = nextProps.spCases
    const nextFilter = nextProps.filter
    const nextNotifications = nextProps.notifications

    if (!filter || !_.isEqual(filter.values, nextFilter.values)) {
      fetchSpCases(user.id, 'first', total, offset, perPage, nextFilter)
    }

    if (!_.isEmpty(notifications) && (nextNotifications.length > notifications.length)) {
      fetchSpCases(user.id, null, total, offset, perPage, nextFilter, false)
    }

    {/* TODO: Temporary solution for "Banco Olé Consignado" and "Banco Fibra" and "Liberty" */ }
    if (filter && !_.isEqual(filter.values ? filter.values.companies : null, nextFilter.values ? nextFilter.values.companies : null)) {
      if (nextFilter.values?.companies?.length === 1) {
        fetchFiltersClassifiers(nextFilter.values.companies[0])
      }
      else {
        if (user.lawFirm !== null && nextFilter.values?.companies?.length > 1) {
          changeFilterClassifiers([])
        }
      }
      if (!nextFilter.values || !nextFilter.values.companies) return

      // changeFilterClassifiers([])

      // if (nextFilter.values.companies.indexOf('2c9f92165d38d51c015d767b24e1007e') != -1) {
      //   changeFilterClassifiers([{ "value": 10, "label": "Pré-Sentença" }, { "value": 11, "label": "Pós-Sentença" }])
      // } else if (nextFilter.values.companies.indexOf('e8e6642987b87f4adbf8f2255547baaa') != -1) {
      //   changeFilterClassifiers([{ "value": 20, "label": "Indenizatórias" }, { "value": 21, "label": "Revisional de Contrato" }, { "value": 22, "label": "Busca e Apreenção" }, { "value": 23, "label": "Outros" }])
      // } else if (nextFilter.values.companies.indexOf('2c9f92165af679d6015af679ef240001') != -1) {
      //   changeFilterClassifiers([{ "value": 18, "label": "Teste" }, { "value": 19, "label": "teste2" }])
      // } else if (nextFilter.values.companies.indexOf('044dbd10c41d11e9ad5adda2a740b7af') != -1 || nextFilter.values.companies.indexOf('0b464440c35d11e9ad5adda2a740b7af') != -1 || nextFilter.values.companies.indexOf('d14773c0c41c11e9ad5adda2a740b7af') != -1) {
      //   changeFilterClassifiers([{ "value": 130, "label": "Anuência" }, { "value": 131, "label": "Salvado" }, { "value": 132, "label": "Menor Envolvido" }, { "value": 133, "label": "Defesa do Segurado" }, { "value": 134, "label": "Salvados (Salvado ficando com o autor)" }, { "value": 135, "label": "Salvados (Salvado ficando com a Cia)" }, { "value": 136, "label": "Demais Casos" }])
      // }
    }
  }


  render() {
    const {
      filter,
      user,
      loading,
      spCases,
      total,
      offset,
      perPage,
      visible,
      companies,
      lawFirms,
      createdBy,
      classifiers,
      archiveReasons,
      notifications,
      changeFilterVisible,
      fetchSpCases,
      change
    } = this.props

    return (
      <div className="my-cases-page">
        <div className="my-cases-page__header">
          <Breadcrumb routes={['Meus Casos']} />
          {user.role === 'company' &&
            <span
              className={loading.exporting && loading.visible ?
                "my-cases-page__action my-cases-page__action--loading" :
                "my-cases-page__action"}
              onClick={() => !loading.exporting && fetchSpCases(user.id, null, total, offset, perPage, filter, true, true)}>
              {loading.exporting && loading.visible ? 'Exportando...' : 'Exportar Casos'}
            </span>
          }
          {user.role === 'lawyer' &&
            <NavLink to="/inserir-caso-pre-contencioso"><span>Inserir Caso</span></NavLink>
          }
        </div>
        <Pagination
          page="meus-casos"
          total={total}
          offset={offset}
          perPage={perPage}
          leftActionIsVisible={visible}
          loading={loading.visible}
          onSelect={action => {
            action === 'Filtrar' ?
              changeFilterVisible(!visible) :
              fetchSpCases(user.id, action, total, offset, perPage, filter)
          }} />
        {((!loading.exporting && !loading.visible) || loading.exporting) && total > 0 &&
          <Row>
            <Col className="my-cases-page__content">
              <Row>
                {spCases.map(spCase => (
                  <Col key={spCase.id} md="50%" lg="33.33%">
                    <MyCasesPageCard
                      id={spCase.id}
                      to={`/meus-casos/${spCase.id}`}
                      role={user.role}
                      origin={spCase.origin}
                      timeLeft={spCase.timeLeft}
                      status={spCase.caseStatus}
                      viewed={spCase.viewed}
                      lawsuitNumber={spCase.lawsuitNumber}
                      client={spCase.client}
                      lawyer={spCase.lawyer}
                      company={spCase.company}
                      lawFirm={spCase.lawFirm}
                      guaranteed={spCase.guaranteed}
                      lastMessage={spCase.lastMessage}
                      turn={spCase.turn}
                      notifications={notifications}
                      remainingTime={spCase.remainingTime}
                      admin={user.admin} />
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        }
        {((!loading.exporting && !loading.visible) || loading.exporting) && total === 0 &&
          <NotFoundBox
            img={notFoundImg}
            title="Não encontramos nenhum caso no momento."
            text="Em breve, esta página estará cheia e sua mesa com menos processos."
            marginTop={20}
          />
        }
        {loading.visible && !loading.exporting &&
          <LoadingBox />
        }
        <MyCasesPageFilter
          filter={filter}
          visible={visible}
          role={user.role}
          companies={companies}
          lawFirms={lawFirms}
          createdBy={createdBy}
          classifiers={classifiers}
          archiveReasons={archiveReasons}
          admin={user.admin}
          handleOpen={() => changeFilterVisible(true)}
          handleClose={() => changeFilterVisible(false)}
          handleReset={(section) => change('filter', section, '')}
          handleSelectAll={(section, values) => change('filter', section, values)}
        />
      </div>
    )
  }
}

MyCasesPage = connect(
  (state, ownProps) => ({
    filter: state.form.filter,
    user: state.auth.user,
    loading: state.myCasesPage.loading,
    spCases: state.myCasesPage.spCases,
    total: state.myCasesPage.total,
    offset: state.myCasesPage.offset,
    perPage: state.myCasesPage.perPage,
    visible: state.myCasesPage.filter.visible,
    companies: state.myCasesPage.filter.companies,
    lawFirms: state.myCasesPage.filter.lawFirms,
    createdBy: state.myCasesPage.filter.createdBy,
    classifiers: state.myCasesPage.filter.classifiers,
    archiveReasons: state.myCasesPage.filter.archiveReasons,
    notifications: state.notify.notifications,
    onboarding: state.onboarding,
    location: ownProps.location
  }), { changeFilterVisible, changeFilterClassifiers, fetchSpCases, fetchFilters, fetchFiltersClassifiers, fetchFiltersArchiveReasons, reset, change })(MyCasesPage)

export default withParams(MyCasesPage)
